export { formatDateTime } from '../RiderDriverExclusions/exclusionFormatters';

export const STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
};

// An entry carries no `id` (per HITCH-5504's merged DTO). React keys and the
// load-more dedupe both need a stable per-row identity, so this composite
// stands in for one: a driver can only have one claim on a given quest
// claimed at a given instant.
export const claimKey = (row) => `${row.driverUserId}:${row.questId}:${row.claimedAt}`;

// currentCount/targetCount are filled only for ACTIVE claims and can be null
// even then — render the dash rather than a misleading "0/—".
export const formatProgress = (row) => {
  if (row.currentCount == null || row.targetCount == null) return '—';
  return `${row.currentCount}/${row.targetCount}`;
};

const USD_FORMATTER = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// payoutAmountCents is in cents; divide before formatting as USD.
export const formatPayoutAmount = (amountCents) => (amountCents == null ? '—' : USD_FORMATTER.format(amountCents / 100));

export const PAYOUT_STATUS_LABELS = {
  PENDING: 'Pending',
  PAID: 'Paid',
  FAILED: 'Failed',
};

// A null payoutStatus on a COMPLETED claim is the HITCH bug this page exists
// to surface — a completed quest with no payout row — and must never read as
// "Pending", which would hide the gap.
export const payoutStatusLabel = (status) => {
  if (!status) return 'No payout record';
  return PAYOUT_STATUS_LABELS[status] || status;
};

const shortId = (id) => (id ? `${id.slice(0, 8)}…` : '');

// Falls back through every identifier the row might carry, down to a
// shortened driverUserId, so a Postgres-only driver with no name, email, or
// phone (and no driverMongoId) still shows something ops can search on
// instead of a blank cell.
export const driverLabel = (row) =>
  row.driverName || row.driverEmail || row.driverPhone || shortId(row.driverMongoId || row.driverUserId);
